module.exports = __webpack_public_path__ + "img/7.309f54a1.png";